import React, { useCallback } from 'react';
import { useTranslation } from '../../../localization/useTranslation';
import { Checkbox } from '@patternfly/react-core';
import PropTypes from 'prop-types';
import { ModelPropType } from '../ModelPropTypes';

const CheckboxComponent = ({ model, value, onChange }) => {
  const T = useTranslation();

  const _onChange = useCallback((_event, isChecked) => {
    onChange(model, isChecked);
  }, [model, onChange]);

  return (
    <Checkbox
      id={model.path}
      label={T.localize(model.label)}
      placeholder={T.localize(model.placeholder)}
      isChecked={value}
      isDisabled={model.disabled || false}
      onChange={_onChange}
    />
  );
};

CheckboxComponent.propTypes = {
  model: ModelPropType,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
};

export default React.memo(CheckboxComponent);
